<div class="accordion-group" id="accordion" role="region" aria-labelledby="accordion-heading">
  <div *ngFor="let category of items; let i = index" class="accordion">
    <h2 class="accordion-header" id="heading{{i}}">
      <button class="accordion-button" type="button" (click)="toggle(i)" [class.collapsed]="activeIndex !== i"
        [attr.aria-expanded]="activeIndex === i ? 'true' : 'false'" [attr.aria-controls]="'collapse' + i" tabindex="0"
        [attr.aria-label]="'Expandir ou colapsar a categoria ' + category.name">
        {{ category.name }}
        <i class="bi bi-chevron-down" [ngClass]="{ 'rotated': activeIndex === i }" aria-hidden="true"></i>
      </button>
    </h2>
    <div *ngIf="activeIndex === i" class="accordion-collapse collapse show" [attr.id]="'collapse' + i"
      [attr.aria-labelledby]="'heading' + i" [attr.aria-hidden]="activeIndex !== i" aria-live="assertive">
      <div class="accordion-body">
        <div *ngFor="let item of category.links; let j = index">
          <div class="accordion-body-link">
            <span>
              {{ item.title }}
              <a [href]="item.url" target="_blank" class="link-wrap">
                {{ item.url }}
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>